<template>
  <div class="patient-cid-selector">
    <div class="d-flex align-center mb-2">
      <v-icon small color="catTeal" class="mr-1">mdi-clipboard-list-outline</v-icon>
      <span class="caption font-weight-medium" style="color: #0e7490">
        Diagnósticos (CID) do paciente
      </span>
      <v-spacer></v-spacer>
      <span v-if="model.length" class="caption grey--text">
        {{ model.length }} selecionado(s)
      </span>
    </div>

    <!-- Carregando -->
    <div v-if="loading" class="py-2">
      <v-progress-circular
        indeterminate
        size="20"
        width="2"
        color="catTeal"
      ></v-progress-circular>
      <span class="caption grey--text ml-2">Carregando CIDs...</span>
    </div>

    <!-- Sem CIDs cadastrados -->
    <v-alert
      v-else-if="cids.length === 0"
      dense
      text
      type="info"
      color="catTeal"
      class="mb-0 rounded-lg caption"
      icon="mdi-information-outline"
    >
      Este paciente ainda não tem CIDs cadastrados. Adicione no card de CIDs do
      perfil ou pela consulta.
    </v-alert>

    <!-- Chips selecionáveis -->
    <div v-else>
      <v-chip
        v-for="cid in cids"
        :key="cid.id"
        class="ma-1"
        :color="isSelected(cid) ? '#0E7490' : undefined"
        :text-color="isSelected(cid) ? 'white' : undefined"
        :outlined="!isSelected(cid)"
        small
        @click="toggle(cid)"
      >
        <v-icon left x-small>
          {{ isSelected(cid) ? "mdi-check-circle" : "mdi-plus-circle-outline" }}
        </v-icon>
        <strong class="mr-1">{{ cid.code }}</strong>
        {{ cid.description }}
      </v-chip>
    </div>
  </div>
</template>

<script>
import { getConditionsByPatient } from "@/services/conditionService";

export default {
  name: "PatientCidSelector",

  props: {
    patientId: { type: [String, Number], required: true },
    // Array de ids de patient_conditions selecionados (v-model).
    // O vínculo na prescrição é via correlations (item projetado ↔ condition).
    value: { type: Array, default: () => [] },
  },

  data() {
    return {
      cids: [],
      loading: false,
    };
  },

  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  watch: {
    patientId: "fetchCids",
  },

  created() {
    this.fetchCids();
  },

  methods: {
    async fetchCids() {
      if (!this.patientId) return;
      this.loading = true;
      try {
        this.cids = await getConditionsByPatient(this.patientId);
      } catch (err) {
        console.error("Erro ao carregar CIDs do paciente:", err);
        this.cids = [];
      } finally {
        this.loading = false;
      }
    },

    isSelected(cid) {
      return this.model.includes(cid.id);
    },

    toggle(cid) {
      if (this.isSelected(cid)) {
        this.$emit(
          "input",
          this.model.filter((id) => id !== cid.id),
        );
      } else {
        this.$emit("input", [...this.model, cid.id]);
      }
    },
  },
};
</script>

<style scoped>
.patient-cid-selector {
  border: 1px solid #cffafe;
  background: #f7feff;
  border-radius: 10px;
  padding: 10px 12px;
}
</style>
